var EmailFormOptimizedContactChannelView, FAQHomeModel, FAQTrendingArticlesView, StepTwoV2CMSView, SupportCMSModel, SupportCategorizationView, SupportChatSuccessView, SupportEmailFormIntlFlexibleContactChannelsView, SupportEmailSuccessView, SupportFlexibleContactChannelModel, SupportLiveChatModel, SupportLiveChatView, SupportOptimizedContactChannelsModel, SupportOrderModel, SupportOrdersCollection, SupportProblemSolvedView, SupportUserSignInView, SupportV2StepActionsModel, SupportVerticalHelpWizardViewManager, SupportVerticalINTLStepThreeView, SupportVerticalStepOneView;

SupportVerticalINTLStepThreeView = require('../views/step_three/INTL/vertical_view');

SupportOrdersCollection = require('../collections/orders');

SupportOrderModel = require('../models/order');

SupportCategorizationView = require('../views/categorization_view');

SupportVerticalStepOneView = require('../views/step_one/vertical_view');

SupportV2StepActionsModel = require('../models/v2_step_action');

StepTwoV2CMSView = require('../views/step_two/CMS/v2_cms_view');

SupportCMSModel = require('../models/CMS');

SupportFlexibleContactChannelModel = require('../models/flexible_contact_channels');

SupportLiveChatModel = require('../models/live_chat');

SupportLiveChatView = require('../views/live_chat_view');

SupportOptimizedContactChannelsModel = require('../models/optimized_contact_channels');

FAQHomeModel = require('../../../faq/frontend/models/home');

FAQTrendingArticlesView = require('../../../faq/frontend/views/trendingArticles');

SupportEmailSuccessView = require('../views/email_success_view');

SupportChatSuccessView = require('../views/chat_success_view');

SupportProblemSolvedView = require('../views/problem_solved_view');

SupportUserSignInView = require('../views/user_sign_in_view');

SupportEmailFormIntlFlexibleContactChannelsView = require('../views/email_form/INTL/flexible_contact_channels');

EmailFormOptimizedContactChannelView = require('../views/email_form/common/optimized_contact_channel_view');

SupportVerticalHelpWizardViewManager = (function() {
  function SupportVerticalHelpWizardViewManager() {
    this.configureContentModel();
    this.configureFlexibleContentChannelsModel();
    this.configureOptimizedContactChannelsModel();
    this.configurePreEmailView();
    this.homeModel = new FAQHomeModel();
    this.initLiveChat();
    Groupon.Support.OrdersCollection = new SupportOrdersCollection();
    Groupon.Support.currentOrdersFilter = Groupon.Support.OrdersCollection.createPurchaseDateDescendingFilter();
    Groupon.Support.OrderModel = new SupportOrderModel();
    Groupon.Support.stepActionModel = new SupportV2StepActionsModel({
      showVerticalView: true
    });
    this.stackedViews = [];
  }

  SupportVerticalHelpWizardViewManager.prototype.show = function(view, params) {
    var container, isNewViewAddedToStack;
    container = params.container;
    isNewViewAddedToStack = this.setCurrentView(view, container);
    if (isNewViewAddedToStack) {
      this.moveActiveContainerToInactiveState();
      this.activateContainer(container);
      Groupon.Support.CURRENTVIEW.render(params);
      $('.step-container', container).html(Groupon.Support.CURRENTVIEW.el);
    } else {
      this.moveActiveContainerToDefaultState();
      this.activateContainer(container);
    }
    return toggleCallUs(Groupon.Support.CURRENTVIEW.id);
  };

  SupportVerticalHelpWizardViewManager.prototype.scrollTo = function($container) {
    var hash, ref;
    if ($container) {
      hash = {
        scrollTop: (ref = $container.offset()) != null ? ref.top : void 0
      };
      return $('html, body').animate(hash, 1000);
    }
  };

  SupportVerticalHelpWizardViewManager.prototype.renderTrendingArticles = function() {
    return this.homeModel.fetch({
      success: (function(_this) {
        return function(model, response, options) {
          var trendingArticlesView;
          stopTimer("t_fh");
          trendingArticlesView = new FAQTrendingArticlesView({
            model: _this.homeModel
          });
          return trendingArticlesView.render();
        };
      })(this),
      error: (function(_this) {
        return function(model, xhr, options) {
          _this.hideTrendingArticles();
          return stopTimer("t_fh");
        };
      })(this)
    });
  };

  SupportVerticalHelpWizardViewManager.prototype.hideTrendingArticles = function() {
    return $('.trending-articles-container').hide();
  };

  SupportVerticalHelpWizardViewManager.prototype.setCurrentView = function(currentView, container) {
    var peekedTopView, ref;
    if (this.removeStackedViewsAndUpdateCurrentView(currentView)) {
      return false;
    }
    peekedTopView = this.peekStackedViews();
    if (((peekedTopView != null ? (ref = peekedTopView.view) != null ? ref.id : void 0 : void 0) != null) && ((currentView != null ? currentView.id : void 0) != null) && peekedTopView.view.id === currentView.id) {
      this.removeView();
    }
    Groupon.Support.CURRENTVIEW = currentView;
    this.addView(currentView, container);
    return true;
  };

  SupportVerticalHelpWizardViewManager.prototype.removeStackedViewsAndUpdateCurrentView = function(currentView) {
    var isCurrentViewUpdated, isRemoved, peekedTopView;
    isCurrentViewUpdated = false;
    isRemoved = false;
    while (true) {
      peekedTopView = this.peekStackedViews();
      if (((peekedTopView != null ? peekedTopView.view.id : void 0) != null) && ((currentView != null ? currentView.id : void 0) != null) && peekedTopView.view.id > currentView.id) {
        isRemoved = true;
        this.moveContainerToDefaultState(peekedTopView.container);
        this.removeView();
      } else if (isRemoved && peekedTopView) {
        this.activateContainer(peekedTopView.container);
        Groupon.Support.CURRENTVIEW = peekedTopView.view;
        isCurrentViewUpdated = true;
        break;
      } else {
        break;
      }
    }
    return isCurrentViewUpdated;
  };

  SupportVerticalHelpWizardViewManager.prototype.addView = function(currentView, container) {
    return this.stackedViews.push({
      view: currentView,
      container: container
    });
  };

  SupportVerticalHelpWizardViewManager.prototype.removeAllStackedViews = function() {
    var peekedTopView;
    while (true) {
      this.removeView();
      peekedTopView = this.peekStackedViews();
      if (!peekedTopView) {
        break;
      }
    }
    this.moveAllContainerstoDefaultState();
    return Groupon.Support.CURRENTVIEW = null;
  };

  SupportVerticalHelpWizardViewManager.prototype.removeView = function() {
    var popedTopView;
    popedTopView = this.stackedViews.pop();
    if ((popedTopView != null ? popedTopView.view : void 0) != null) {
      return popedTopView.view.remove();
    }
  };

  SupportVerticalHelpWizardViewManager.prototype.peekStackedViews = function() {
    var stackedView;
    if (this.stackedViews.length > 0) {
      return stackedView = this.stackedViews[this.stackedViews.length - 1];
    } else {
      return null;
    }
  };

  SupportVerticalHelpWizardViewManager.prototype.moveActiveContainerToDefaultState = function() {
    $('.web-v2-circle.active').removeClass('active').removeClass('in-active');
    $('.web-v2-circle-text.active').removeClass('active').removeClass('in-active');
    return $('.web-v2-help-text.active').removeClass('active').removeClass('in-active');
  };

  SupportVerticalHelpWizardViewManager.prototype.moveActiveContainerToInactiveState = function() {
    $('.web-v2-circle.active').removeClass('active').addClass('in-active');
    $('.web-v2-circle-text.active').removeClass('active').addClass('in-active');
    return $('.web-v2-help-text.active').removeClass('active').addClass('in-active');
  };

  SupportVerticalHelpWizardViewManager.prototype.inActivateContainer = function(container) {
    $('.web-v2-circle', container).removeClass('active').addClass('in-active');
    $('.web-v2-circle-text', container).removeClass('active').addClass('in-active');
    return $('.web-v2-help-text', container).removeClass('active').addClass('in-active');
  };

  SupportVerticalHelpWizardViewManager.prototype.moveContainerToDefaultState = function(container) {
    $('.web-v2-circle', container).removeClass('active').removeClass('in-active');
    $('.web-v2-circle-text', container).removeClass('active').removeClass('in-active');
    return $('.web-v2-help-text', container).removeClass('active').removeClass('in-active');
  };

  SupportVerticalHelpWizardViewManager.prototype.activateContainer = function(container) {
    $('.web-v2-circle', container).removeClass('in-active').addClass('active');
    $('.web-v2-circle-text', container).removeClass('in-active').addClass('active');
    return $('.web-v2-help-text', container).removeClass('in-active').addClass('active');
  };

  SupportVerticalHelpWizardViewManager.prototype.moveAllContainerstoDefaultState = function() {
    _.each($('.web-v2-circle'), function(ele) {
      return $(ele).removeClass('active').removeClass('in-active');
    });
    _.each($('.web-v2-circle-text'), function(ele) {
      return $(ele).removeClass('active').removeClass('in-active');
    });
    return _.each($('.web-v2-help-text'), function(ele) {
      return $(ele).removeClass('active').removeClass('in-active');
    });
  };

  SupportVerticalHelpWizardViewManager.prototype.checkIfVerticalContainerIsVisible = function() {
    return $('.vertical-container').is(":visible");
  };

  SupportVerticalHelpWizardViewManager.prototype.resetVerticalContainer = function() {
    this.removeAllStackedViews();
    this.categorizationView.resetGlobalValues();
    this.categorizationView.deActivateCurrentActiveButton();
    this.activateContainer($('#v2_step1'));
    return $('.vertical-container').hide();
  };

  SupportVerticalHelpWizardViewManager.prototype.render = function() {
    var $container;
    $container = $('#v2_step1');
    this.renderTrendingArticles();
    this.categorizationView = new SupportCategorizationView({
      el: $('.category-buttons', $container)
    });
    this.categorizationView.render();
    return this.scrollTo($('.page_header'));
  };

  SupportVerticalHelpWizardViewManager.prototype.renderIntermediateView = function() {};

  SupportVerticalHelpWizardViewManager.prototype.renderOrders = function() {
    var $container, stepOneView;
    if (!currentUser) {
      this.renderUserSignIn({
        myOrder: true,
        id: "my-order-sign-in"
      });
    }
    this.removeAllStackedViews();
    $container = $('#v2_step1');
    stepOneView = this.getStepOneView();
    this.show(stepOneView, {
      container: $container
    });
    this.scrollTo($container);
    return stepOneView;
  };

  SupportVerticalHelpWizardViewManager.prototype.renderOrderDetails = function(order) {
    var $container, stepOneView;
    $container = $('#v2_step1');
    stepOneView = this.getStepOneView();
    this.show(stepOneView, {
      container: $container,
      order: order
    });
    this.scrollTo($container);
    return stepOneView;
  };

  SupportVerticalHelpWizardViewManager.prototype.renderDropDowns = function() {
    var $container, stepTwoView;
    if (this.checkIfVerticalContainerIsVisible()) {
      if (!Groupon.Support.currentOrder) {
        this.removeAllStackedViews();
        this.activateContainer($('#v2_step1'));
      }
      $container = $('#v2_step2');
      stepTwoView = this.getStepTwoView();
      this.show(stepTwoView, {
        container: $container
      });
      this.scrollTo($container);
      return stepTwoView;
    } else {
      return redirectToHelpWizard();
    }
  };

  SupportVerticalHelpWizardViewManager.prototype.renderUserSignIn = function(options) {
    var $container, userSignInView;
    this.removeAllStackedViews();
    $container = $('#v2_step1');
    userSignInView = this.getUserSignView(options);
    this.show(userSignInView, {
      container: $container
    });
    this.scrollTo($container);
    return userSignInView;
  };

  SupportVerticalHelpWizardViewManager.prototype.getUserSignView = function(options) {
    return new SupportUserSignInView(options);
  };

  SupportVerticalHelpWizardViewManager.prototype.renderContactChannels = function() {
    var $container, stepThreeView;
    if (this.checkIfVerticalContainerIsVisible()) {
      $container = $('#v2_step3');
      stepThreeView = this.getStepThreeView();
      this.show(stepThreeView, {
        container: $container
      });
      stepThreeView.postRenderhandler();
      this.scrollTo($container);
      return stepThreeView;
    } else {
      return redirectToHelpWizard();
    }
  };

  SupportVerticalHelpWizardViewManager.prototype.ticketSuccess = function() {
    var $container, ticketSuccessView;
    this.resetVerticalContainer();
    $container = $('#v2_other');
    ticketSuccessView = new SupportEmailSuccessView;
    this.show(ticketSuccessView, {
      container: $container
    });
    this.scrollTo($container);
    return ticketSuccessView;
  };

  SupportVerticalHelpWizardViewManager.prototype.chatSuccess = function() {
    var $container, chatSuccessView;
    this.resetVerticalContainer();
    $container = $('#v2_other');
    chatSuccessView = new SupportChatSuccessView;
    this.show(chatSuccessView, {
      container: $container
    });
    this.scrollTo($container);
    return chatSuccessView;
  };

  SupportVerticalHelpWizardViewManager.prototype.renderProblemSolved = function() {
    var $container, problemSolvedView;
    $('.vertical-container').hide();
    $container = $('#v2_other');
    problemSolvedView = new SupportProblemSolvedView({
      isV2: true
    });
    this.show(problemSolvedView, {
      container: $container
    });
    this.scrollTo($container);
    return problemSolvedView;
  };

  SupportVerticalHelpWizardViewManager.prototype.getStepOneView = function() {
    return new SupportVerticalStepOneView();
  };

  SupportVerticalHelpWizardViewManager.prototype.getStepTwoView = function() {
    return Groupon.Support.StepTwoView = new StepTwoV2CMSView({
      dropDownModel: Groupon.Support.ContentModel.dropDowns
    });
  };

  SupportVerticalHelpWizardViewManager.prototype.getStepThreeView = function() {
    return new SupportVerticalINTLStepThreeView();
  };

  SupportVerticalHelpWizardViewManager.prototype.configureContentModel = function() {
    return Groupon.Support.ContentModel = new SupportCMSModel;
  };

  SupportVerticalHelpWizardViewManager.prototype.configureFlexibleContentChannelsModel = function() {
    return Groupon.Support.FlexibleContactChannelModel = new SupportFlexibleContactChannelModel;
  };

  SupportVerticalHelpWizardViewManager.prototype.configureOptimizedContactChannelsModel = function() {
    return Groupon.Support.OptimizedContactChannelsModel = new SupportOptimizedContactChannelsModel;
  };

  SupportVerticalHelpWizardViewManager.prototype.configurePreEmailView = function() {
    if (window.evaluate(window.experiments.showFlexibleContactChannels)) {
      return Groupon.Support.PreEmailView = SupportEmailFormIntlFlexibleContactChannelsView;
    } else {
      return Groupon.Support.PreEmailView = EmailFormOptimizedContactChannelView;
    }
  };

  SupportVerticalHelpWizardViewManager.prototype.initLiveChat = function() {
    Groupon.Support.LiveChatModel = new SupportLiveChatModel();
    return Groupon.Support.LiveChatView = new SupportLiveChatView({
      model: Groupon.Support.LiveChatModel
    });
  };

  return SupportVerticalHelpWizardViewManager;

})();

module.exports = SupportVerticalHelpWizardViewManager;

//# sourceMappingURL=data:application/json;base64,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
